export interface LendAppendixRequest {
  collectionId: number
  revision: number
}

export function LendAppendixRequestToJSON(value: LendAppendixRequest): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
